<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main" v-if="!empty">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>网关</span>
          <el-button v-if="multipleSelection.length == 0" style="float: right;" type="primary"
            @click="addBtn">创建</el-button>
          <div style="float: right;" v-if="multipleSelection.length != 0">
            <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>
              个</span>
            <el-dropdown trigger="click" @command="operationBtn">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{type:'del',para:multipleSelection}">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <el-input class="input-with-select" placeholder="搜索网关名称/编号" v-model="search" @keyup.enter.native="searchBtn">
            <el-button slot="append" @click="searchBtn" :disabled="search.length == 0 ? true : false"
              icon="el-icon-search" :class="search.length == 0 ? 'ccc' : 'blue'"></el-button>
          </el-input>
          <el-select v-model="status" clearable placeholder="状态" @change="changeStatus">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table ref="multipleTable" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="名称" min-width="150px">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="detailBtn(scope.row.id)">
                {{ scope.row.name }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="编号"></el-table-column>
          <el-table-column prop="onlineStatus" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.onlineStatus==0"> <i class="redDot"></i>离线</span>
              <span v-else-if="scope.row.onlineStatus==1"> <i class="greenDot"></i>在线</span>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="command">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ type: 'edit', id: scope.row.id }">编辑</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'del', id: scope.row.id }">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10,50,100,200,500,1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 没有网关显示的内容 -->
    <div class="emptyMain" v-if="empty">
      <el-card class="box-card">
        <img src="../../assets/images/wifi.png" alt="" />
        <p style="color:#303133">您还没有创建任何网关</p>
        <br />
        <el-button>了解详情</el-button>
        <el-button type="primary" @click="addBtn">创建网关</el-button>
      </el-card>
    </div>
  </div>
</template>
<script>
  import API from "../../api/api";
  export default {
    data() {
      return {
        empty: false, //控制数据为空展示空页面
        total: 0,
        pageSize: 10,
        currentPage: 1,
        loading: false, //加载条
        search: "",
        status: '',//状态下拉数据
        statusList: [//状态数组
          {
            value: 1,
            label: '在线'
          },
          {
            value: 0,
            label: '离线'
          }
        ],
        tableData: [],
        multipleSelection: []
      };
    },
    created() { },
    methods: {
      //获取列表数据--只在进入页面时调用，不能复用
      getPage() {
        let para = {
          type: 2,//网关
          pageSize: this.pageSize,
          currentPage: this.currentPage
        };
        this.loading = true; /*显示加载条*/
        API.platformMduModulePage(para)
          .then(res => {
            if (res.code == 1) {
              if (res.data.resultPage.length == 0) {
                this.empty = true; //没有数据显示空页面
              }
              this.tableData = res.data.resultPage;
              this.total = res.data.total;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })

      },
      //获取列表复用
      getpageList() {
        let para = {
          type: 2,//网关
          code: this.search, //搜索栏
          onlineStatus: this.status, //下拉搜索
          pageSize: this.pageSize,
          currentPage: this.currentPage
        };
        this.loading = true; /*显示加载条*/
        API.platformMduModulePage(para)
          .then(res => {
            if (res.code == 1) {
              this.tableData = res.data.resultPage;
              this.total = res.data.total;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })

      },
      //搜索功能
      searchBtn() {
        this.status = '',//下拉选项为空
          this.getpageList();
      },
      //下拉搜索
      changeStatus() {
        this.search = "";//清空搜索条件
        this.getpageList();
      },
      //清除搜索条件
      reset() {
        this.search = "";
        this.status = "";
        this.getpageList();
      },
      //选择的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //批量操作-删除
      operationBtn(val) {
        if (val.type == 'del') {
          let arr = []
          val.para.forEach(element => {
            arr.push(element.id)
          });
          let str = arr.join(',')
          this.delBtn(str)
        }
      },
      //单独删除功能
      command(val) {
        if (val.type == 'del') {
          let str = val.id
          this.delBtn(str)
        }
        if (val.type == 'edit') {
          this.$router.push({
            path: "/device/gatewayAdd",
            query: {
              id: val.id,
              flag: 'edit'
            }
          });
        }
      },
      //删除功能 单独批量公用
      delBtn(delID) {
        let para = {
          ids: delID
        }
        this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.delPlatformMduModule(para).then(res => {
            if (res.code == 1) {
              this.$message.success('删除成功');
              this.getpageList();
            } else {
              this.$message.error('删除失败');
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //跳转到详情页
      detailBtn(id) {
        this.$router.push({
          path: "/device/gatewayDetails",
          query: {
            id: id
          }
        });
      },
      //跳转创建网关页
      addBtn() {
        this.$router.push({
          path: "/device/gatewayAdd"
        });
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.getpageList();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getpageList();
      }
    },
    mounted() {
      this.getPage();
    }
  };
</script>


// WEBPACK FOOTER //
// src/views/platform/gatewayManagement.vue